<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div style='text-align:center;color:#fff;font-size:20px;padding:20px 0;'>
      艺袋鼠代理管理
    </div>
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'
import router from '@/router'
import Cookies from 'js-cookie'

export default {
  components: {
    LoginForm
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit ({ userName, password }) {
         
      this.handleLogin({ userName, password }).then(res => {
        if (res.code == 200) {
         
          this.$store.commit('setToken', res.data.token)
          Cookies.set('user', userName)
          
          this.getUserInfo().then(res => {
            this.$router.push({
              name: this.$config.homeName
            })
          })
        } else {
          this.$Message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>

</style>
